import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { WFManageFilterConfig } from 'app/shared/filter/filter.constant';
import { INT_WFMANAGE_ACTIONS, WFMANAGE} from "app/shared/actions/actions.constants";
import { ApplicationService } from "app/services/application.service";
import { CarrierService } from "app/services/carrier.service";
import { UtilityServiceService } from "app/services/utility-service.service";
import { WorkflowService } from "app/services/workflow.service";
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";
import { FilterService } from "app/shared/filter/filter.service";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { ModalDirective } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { truncate } from "fs";



@Component({
  selector: 'app-wfmanageactivity',
  templateUrl: './wfmanageactivity.component.html',
  styleUrls: ['./wfmanageactivity.component.scss']
})
export class WfmanageactivityComponent implements OnInit {

  public modalRef: BsModalRef;
  @ViewChild("childModal", { static: true }) childModal: ModalDirective;

  isLoading: Boolean = false;

  activities: any = [];
  message: string = "Loading activities, please wait...";
  statuses: any = [];
  keyword: any = {};

  //#region Paging
  page = 1;
  pageSize: number = 5;
  currentPage = 1;
  //#endregion
  
  isEmpty: boolean = false;
  disabled = false;
  ShowFilter = false;
  limitSelection = false;
  dropdownSettings: any = {};
  carrierNumber: string;
  carrierName: string;
  processFlag: boolean = false;
  currentUserName: string = "";
  userData: any = environment.authWebApi.userData;
  workflow_role: number;
  workflow_user: string;
  selectedcarrier: any = null;
  selectedIndex: number;

  companyRegNumber: string;
  first_Name: string;
  surname: string;
  id_number: string;
  ApplicationNumber: string;
  ApplicationType: string;
  Status: string;
  DateAssigned: Date;

  selectedUser: string = "";
  roleUsers: any = [];
  bar_labels: any = [];
  bar_values: any = [];
  bar_data: any = {};
  card_data: any = {};
  user_data = { CountAssigned: 0, TimeTaken: 0 };
  role_id: number;
  activity_id: number;
  assigneduser: string;
  assignedusername: string;
  activity_status: string;

  filtergrid: boolean = false;
  filteruser: any = '';

  application_id: any;
  applicant_name: any;
  application_type: any;

  readmore:boolean = false;

  selectedItems: any = [];

  filterConfig = WFManageFilterConfig;

  wfManageActions = INT_WFMANAGE_ACTIONS;
  selectedItemData: any = [];

  isMultiReassign: boolean = false;

  constructor(
    private service: WorkflowService,
    private carrierService: CarrierService,
    private applicationService: ApplicationService,
    private router: Router,
    private toater: ToastNotificationService,
    private filter: FilterService,
    public utility: UtilityServiceService
  ) {}

  ngOnInit(): void {
    this.workflow_role = this.userData.Roles.find(
      (p) => p.IsWorkflowRole == true
    ).Id;
    this.workflow_user = this.userData.User.UserName;

    this.loadActivities(this.utility.page, this.pageSize);
  }

  //#region MainData
  loadActivities(page: number = 1, pageSize: number = 5) {
    this.isLoading = true;
    this.service.getAllActivity(page, pageSize).subscribe(
      async (result: any) => {
        this.activities = await this.matchApplications(result);
        this.selectedItemData = [];
        this.selectedUser = "";
      },
      (error) => {
        this.toater.error(
          "Failed to load user activity. Please try again",
          "Activity"
        );
        this.isLoading = false;
      }
    );
  }

  matchApplications(results): Observable<any> {
    console.log(results)
    var listactivities: any = [];
    results.data.forEach((item) => {
        var obj = {
          id: item.id,
          applicationId: item.applicationId,
          activityid: item.activityId,
          applicationType: item.applicationType,
          activityStatus: item.activityStatus,
          dateassigned: item.dateassigned,
          datereceived: item.datereceived,
          userassigned: item.userAssigned,
          userassignedname: item.userAssignedName,
          roleassignedid: item.roleAssignedId,
          applicant: item.applicant,
          assignedtogroupyn: item.assignedtogroupyn
        };

        listactivities.push(obj);
    });
    this.onLoadDashboardData();
    this.isLoading = false;
    return listactivities;
  }

  onLoadDashboardData() {
    this.bar_labels = [];
    this.bar_values = [];

    this.service.getDashboardData().subscribe(
      async (result: any) => {
        this.card_data = result.Card;
        this.bar_data = result.Bar;

        for (let key in this.bar_data) {
          this.bar_labels.push(key);
          this.bar_values.push(this.bar_data[key]);
        }
        this.isLoading = false;

        console.log(this.bar_values)
      },
      (error) => {
        this.toater.error(
          "Failed to load user activity. Please try again",
          "Activity"
        );
        this.isLoading = false;
      }
    );
  }

  doPermitAction(event: any) {
    console.log(this.selectedItemData)
    if (event.value == WFMANAGE.ViewUnassigned) {
      this.router.navigate([`/workflow/unassigned`]);
    }else if (event.value == WFMANAGE.ReassignSelected) {
      if(this.selectedItemData.length <= 0){
         this.toater.error("Please select one or more records!","Reassign");
         return;
       }
       
       if (this.hasSameWFType(this.selectedItemData)==true && this.hasSameRole(this.selectedItemData)==true) {
        this.onReassignSelected();
       }else{
        this.toater.error("Cannot reassign activity of different workflow type or role","Reassign");
        return;
       }

    } 
  }

  resetGridData(){
    this.filtergrid = false;
    this.filterActivities();
  }

  filterActivities(page: number = 1, pageSize: number = 50){
    this.isLoading = true;
    this.service.getAllActivity(page, pageSize).subscribe(
      async (result: any) => {
        this.activities = await this.matchFilteredData(result);
      },
      (error) => {
        this.toater.error(
          "Failed to load user activity. Please try again",
          "Activity"
        );
        this.isLoading = false;
      }
    );
  }

  matchFilteredData(results): Observable<any> {
    var listactivities: any = [];
    results.forEach((item) => {
      if(this.filtergrid){
        if(item.userAssignedName == this.filteruser){
          var obj = {
            id: item.id,
            applicationId: item.applicationId,
            activityid: item.activityId,
            applicationType: item.applicationType,
            activityStatus: item.activityStatus,
            dateassigned: item.dateassigned,
            userassigned: item.userAssigned,
            userassignedname: item.userAssignedName,
            roleassignedid: item.roleAssignedId,
            applicant: item.applicant,
          };
  
          listactivities.push(obj);
        }
      }else{
        var obj = {
          id: item.id,
          applicationId: item.applicationId,
          activityid: item.activityId,
          applicationType: item.applicationType,
          activityStatus: item.activityStatus,
          dateassigned: item.dateassigned,
          userassigned: item.userAssigned,
          userassignedname: item.userAssignedName,
          roleassignedid: item.roleAssignedId,
          applicant: item.applicant,
        };

        listactivities.push(obj);
      }        
    });

    this.isLoading = false;
    return listactivities;
  }

  onView(item) {
    this.isLoading = true;
    this.role_id = item.roleassignedid;
    this.activity_id = item.activityid;
    this.assigneduser = item.userassigned;
    this.assignedusername = item.userassignedname;
    this.activity_status = item.activityStatus;
    this.loadRoleUsers(item.roleassignedid);
    this.onLoadUserData();
    this.onWorkflowTracking(item)
  }

  //#endregion

  onWorkflowTracking(item){
    this.application_id = item.applicationId;
    this.applicant_name = item.applicant;
    this.application_type = item.applicationType;

    this.getTimeline(item.applicationId);
  }

  async getTimeline(foreignkeyid){
    this.isLoading = true;
    await this.service.getWorkflowTimeline(foreignkeyid).subscribe(
      (result) => {
        this.activities = result;
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  onReadMore(){
    this.readmore = !this.readmore;
  }

  //#region PoupData

  onMultiReassign(item) {
    this.isLoading = true;
    this.role_id = item.roleassignedid;
    this.activity_id = item.activityid;
    this.assigneduser = item.userassigned;
    this.assignedusername = item.userassignedname;
    this.activity_status = item.activityStatus;
    this.loadRoleUsers(item.roleassignedid);
    this.onLoadUserData();
    this.onWorkflowTracking(item)
  }

  loadRoleUsers(roleid) {
    this.isLoading = true;
    this.service.getRoleUsers(roleid).subscribe(
      async (result: any) => {
        this.setRoleUsers(result);
        this.childModal.show();
        this.isLoading = false;
      },
      (error) => {
        this.toater.error(
          "Failed to load user activity. Please try again",
          "Activity"
        );
        this.isLoading = false;
      }
    );
  }

  onLoadUserData() {
    this.service.getUserData(this.assigneduser, this.activity_id).subscribe(
      async (result: any) => {
        this.user_data = result;
        this.setAssignedActivityPerUser()
        
        this.isLoading = false;
      },
      (error) => {
        this.toater.error(
          "Failed to load user activity. Please try again",
          "Activity"
        );
        this.isLoading = false;
      }
    );
  }

  setRoleUsers(data){
    data.forEach((user:any) => {
    console.log(user.UnavailableYN)

      if(user.UnavailableYN=='true'){
        user.displayName =  user.displayName + " *Away*";
      }

      if(this.bar_data[user.displayName]){
        user.displayName = user.displayName + " (" + this.bar_data[user.displayName] + ")";
      }else{
        user.displayName = user.displayName + " (0)";
      }
    });
    this.roleUsers = data
  }

  setAssignedActivityPerUser(){
    this.roleUsers = this.roleUsers.filter(
      (p) => p.userName != this.assigneduser
    );

    this.roleUsers.forEach((user:any) => {
      console.log(user);
      console.log(this.bar_data)
    });
  }

  onProceed() {
    this.isLoading = true;
    if(this.isMultiReassign==true){

      for (const item of this.selectedItemData){
        this.updateActivity(item.activityid, this.selectedUser);
      }

      this.childModal.hide();
      this.loadActivities();
      this.toater.success(`${this.selectedItemData.length} task(s) successfully reassigned to ${this.selectedUser}`, "Reassign");
      this.isLoading = false;
    }else{
      this.updateActivity(this.activity_id, this.selectedUser);
    }   
  }

  async updateActivity(activity_id, selectedUser){
    this.service
    .reassignActivity(activity_id, selectedUser)
    .subscribe(
      async (result: any) => {
        if(this.isMultiReassign==false){
          this.childModal.hide();
          this.loadActivities();
          this.toater.success("Task successfully reassigned", "Reassign");
        }      
      },
      (error) => {
        this.toater.error(
          "Failed to load user activity. Please try again",
          "Activity"
        );
        this.isLoading = false;
      }
    );
  }

  onCancel() {
    this.childModal.hide();
    this.loadActivities(this.page, this.pageSize);
  }

  //#endregion

  //#region MultiReassign
  onReassignSelected(){
    this.isMultiReassign = true;
    this.role_id = this.selectedItemData[0].roleassignedid;
    this.loadRoleUsers(this.selectedItemData[0].roleassignedid);
  }

  hasSameWFType(items: any){
    let result = true;
    if(items.length >= 1){
      const type = items[0].applicationType;
      items.forEach(element => {
        if(element.applicationType!=type){
          result = false;
        }      
      });
    }  

    return result;
  }

  hasSameRole(items: any){
    let result = true;
    if(items.length > 0){
      const role = items[0].roleassignedid;
      items.forEach(element => {
        if(element.roleassignedid!=role){
          result = false;
        }      
      });
    }  

    return result;
  }

  onChecked(event, item){
    if (event.target.checked) {
      this.selectedItemData.push(item);
    } else {
      const index = this.selectedItemData.indexOf(item, 0);
      if (index > -1) {
        this.selectedItemData.splice(index, 1);
      }
    }
  }

  //#endregion
  
  onSearch() {}

  onReset() {}

  //#region Filters

  applyFilter(filters) {
    this.resetPages();

    if (!filters) {
      this.keyword = {};
      this.loadActivities();
    } else {

    this.selectedItems = filters?.Statuses;
    (this.keyword.WFAppType = filters?.WFAppType? filters?.WFAppType : 0),
    (this.keyword.WFRouteType = filters?.WFRouteType? filters?.WFRouteType : ""),
    (this.keyword.CarrierName = filters?.CarrierName? filters.CarrierName : "ALL"),
    (this.keyword.Statuses = this.selectedItems ? this.selectedItems.map((status) => {  return status.id; }) : []);
    
    if (filters) {
        this.loadFilteredActivities();
      } else {
        this.loadActivities();
      }
    }
  }

  loadFilteredActivities(page: number = 1, pageSize: number = 50) {
    this.isLoading = true;
    this.service
      .getAllActivityFiltered(this.keyword, page, pageSize)
      .subscribe(
        async (result: any) => {
          console.log(result)
          this.activities = await this.matchApplications(result);
        },
        (error) => {
          this.toater.error(
            "Failed to load user activity. Please try again",
            "Activity"
          );
          this.isLoading = false;
        }
      );
  }

  resetPages() {
    this.pageSize = 10;
    this.currentPage = 1;
  }

  //#endregion
  //#region Paging
   onChange = (event) => {
    this.currentPage = 1;
    this.pageSize = event;
    this.loadActivities(1,this.pageSize);
  };

  pager(event) {
    this.page = event;
  }
    
  onNextOrPrevious(page: number = 1) {
    this.loadActivities(page,this.pageSize);
    this.currentPage = page;
    return page;
  }
  //#endregion
}
